import { createPointsActionConverter, PointsAction } from "@t3/shared";
import {
  DocumentData,
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  serverTimestamp,
} from "firebase/firestore";

export const pointsActionConverter = createPointsActionConverter<
  DocumentData,
  QueryDocumentSnapshot
>(serverTimestamp) as FirestoreDataConverter<PointsAction, DocumentData>;
